module.exports = __webpack_public_path__ + "img/card-bg.6880c0a1.png";